import React from 'react';

const CaracteristicaUnoSpc = () => {
  return (
    <section className="pb-lg-22">
      <div className="container">
        <div className="row align-items-center mt-n1-6 mt-sm-n6">
          <div className="col-lg-5 mt-1-6 mt-sm-6">
            <div className="position-relative text-center text-lg-start">
              <img 
                src="/assets/img/productos/pisos-spc/piso-spc-sala-intro.jpg" 
                alt="pisos spc en sala" 
              />
              <div className="position-absolute bottom-n10 right-n10 right-lg-n30 d-none d-sm-block">
                <img 
                  src="/assets/img/productos/pisos-spc/piso-spc-lq6190-3-intro.jpg" 
                  alt="piso spc" 
                  style={{ width: '300px', height: '300px' }} 
                />
              </div>
            </div>
          </div>
          <div className="col-lg-7 mt-1-6 mt-sm-6">
            <div className="ps-lg-2-9 ps-xl-10">
              <div className="mb-1-9 mb-xl-8">
                <span className="text-primary text-uppercase small letter-spacing-4 d-block font-weight-700 mb-2">Piso interiores</span>
                <h2 className="mb-1-6 display-5 font-weight-800 lh-1">Fácil instalación con pisos sistema click</h2>
              </div>
              <div className="ps-1-9 ps-sm-10 ps-lg-20">
                <p className="mb-1-6 mb-sm-2-2">
                Las láminas de vinilo están fabricadas con tecnología de punta y cuentan con un sistema de machihembrado o tipo click. 
                Este sistema permite el montaje y la instalación del material sin necesidad de herramientas especializadas, ya que basta con ajustar las piezas entre sí.
                </p>
                <a href="contacto-decototal" className="butn-style4 secondary"><span>Cotiza con nosotros</span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaracteristicaUnoSpc;
